<template>
  <div class="lab-clinico-page">
    <!-- Hero Section -->
    <header class="hero-section py-5 position-relative">
      <div class="container py-3">
        <!-- Logos -->
        <div
          class="row align-items-center justify-content-center
            mb-4 mb-md-5 hero-logos-row"
        >
          <div class="col-12 col-md-6 text-center mb-4 mb-md-0">
            <router-link
              to="/"
              class="d-inline-flex align-items-center text-decoration-none"
            >
              <!-- eslint-disable -->
              <svg
                id="logo-amii-hero"
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                xml:space="preserve"
                viewBox="0 0 250 190"
                version="1.1"
                class="amii-animated-logo"
              >
                <g id="g11" transform="translate(-14.078742,-15)">
                  <path
                    id="nube"
                    class="fil0 str0"
                    d="M 80.3645,51.4333 C 84.3482,19.1951 36.4712,12.0139
                      27.2943,46.8105 c -1.4216,33.8307 46.3886,38.2723
                      53.0702,4.6228 -0.2829,18.3891 13.7366,22.1167
                      21.2446,8.4157 2.5022,-4.5667 2.8474,-8.8107
                      3.9074,-13.7016 6.5131,-30.0453 41.1244,-25.5072
                      40.2493,5.4702 l 0.009,16.4111 -0.009,-16.4111 C
                      147.4692,16.0364 202.508,17.7243 200.26,51.4333
                      l 0.2813,16.4715 -0.2813,-16.4715 c 1.501,-33.2526
                      49.5022,-32.5328 54.7478,-3.8861 0.9657,5.2737
                      1.5125,12.2994 1.6598,19.8872 0.2813,14.4863
                      0.2448,30.639 -1.1508,41.1661 -5.8564,44.1732
                      -76.9434,50.8064 -79.6948,0.0788 1.2135,53.8592
                      -57.7041,51.9733 -64.1966,17.6293 -0.9645,-5.1027
                      -1.4745,-11.006 -1.0196,-17.6815 C 94.6341,180.8337
                      0.3668,136.7911 25.581,53.5973 l 1.7133,-6.7868"
                    inkscape:connector-curvature="0"
                    style="stroke-linecap:round;stroke-linejoin:round"
                  />
                  <rect
                    id="punto2"
                    class="str1 fil1"
                    x="173.255"
                    y="94.910301"
                    width="4.9043598"
                    height="4.9675398"
                    rx="0.6002"
                    ry="0.6002"
                    style="fill:#00208A;stroke:#00208A;stroke-width:6.64440012"
                  />
                  <rect
                    id="punto1"
                    class="str1 fil1"
                    x="109.55"
                    y="94.499298"
                    width="4.9043598"
                    height="4.9675398"
                    rx="0.6002"
                    ry="0.6002"
                    style="fill:#00208A;stroke:#00208A;stroke-width:6.64440012"
                  />
                  <path
                    id="esteto"
                    class="fil0 str1"
                    d="m 142.348,151.551 -0.0997,36.9673 c 0.0327,15.2
                      18.7399,18.5665 29.262,6.2739 l 7.0332,-7.5885"
                    inkscape:connector-curvature="0"
                    sodipodi:nodetypes="cccc"
                  />
                  <circle
                    id="scopio"
                    style="stroke-linecap:butt;stroke-linejoin:round;"
                    class="str1 fil0"
                    cx="-0.74246454"
                    cy="-257.70447"
                    r="9.7580128"
                    transform="rotate(135)"
                  />
                </g>
              </svg>
              <!-- eslint-enable -->
            </router-link>
          </div>
          <div class="col-12 col-md-6 text-center">
            <span
              class="d-block text-uppercase font-weight-bold text-sage mb-1"
            >
              Con el respaldo y capacitación de:
            </span>
            <a
              href="https://www.instagram.com/tupacientedigital/"
              target="_blank"
              rel="noopener noreferrer"
              class="d-inline-block"
            >
              <img
                src="/img/logo_tupacientedigital.png"
                alt="Tu Paciente Digital"
                class="hero-logo-partner"
              >
            </a>
          </div>
        </div>

        <!-- Main Title & CTA -->
        <div class="row justify-content-center text-center">
          <div class="col-12 col-lg-10">
            <span class="badge-hero mb-3 d-inline-block">
              Sistema Integral de Gestión para Laboratorios Clínicos
            </span>
            <h1 class="hero-title font-weight-bold mb-4">
              Transforme la gestión de su laboratorio:
              <span class="text-gradient-cyan">
                más control, precisión y eficiencia
              </span>
              en cada proceso.
            </h1>
            <p class="hero-subtitle mb-4 px-md-4">
              "Conecte todas las áreas de su laboratorio en un solo flujo de
              trabajo y reduzca los márgenes de error desde la recepción hasta
              la entrega de resultados."
            </p>
            <div class="mt-4">
              <a
                href="#contacto"
                class="btn btn-cta-primary px-4 py-3 shadow-lg"
                @click.prevent="scrollToSection('contacto')"
              >
                Solicite una Demostración Gratis
                <font-awesome-icon
                  :icon="['fas', 'arrow-right']"
                  class="ml-2"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- Sección 1: Introducción -->
    <section class="section-intro py-5">
      <div class="container py-4">
        <div class="intro-card p-4 p-md-5 rounded-lg shadow-sm">
          <h2 class="h2-responsive font-weight-bold text-navy mb-4">
            <font-awesome-icon
              :icon="['fas', 'microscope']"
              class="text-cyan mr-2"
            />
            El nuevo estándar en gestión
          </h2>
          <p class="intro-text text-muted mb-3">
            En el sector salud,
            <strong>cada segundo cuenta y cada resultado importa</strong>.
            Sabemos el nivel de exigencia que enfrenta diariamente su
            laboratorio: entregar resultados con absoluta certeza, mantener una
            imagen impecable ante médicos y pacientes y responder con agilidad
            en un entorno cada vez más competitivo.
          </p>
          <div class="intro-highlight my-4 p-3 p-md-4 rounded-right">
            <p class="font-weight-bold mb-0 text-navy">
              AMII Lab conecta recepción, toma de muestra, procesamiento,
              resultados y entrega en un solo flujo de trabajo, reduciendo
              pasos manuales y márgenes de error. Más que un software, es una
              solución diseñada para darle mayor control sobre su operación y
              elevar la experiencia de sus pacientes.
            </p>
          </div>
          <small class="text-muted font-italic d-block mt-3">
            * El equipo de profesionales de “Tu Paciente Digital” acompaña la
            implementación y adopción del sistema, capacitando al personal en
            buenas prácticas y excelencia en la atención.
          </small>
        </div>
      </div>
    </section>

    <!-- Sección 2: Los 7 Pilares -->
    <section
      id="pilares"
      class="section-pilares py-5 bg-white"
    >
      <div class="container py-4">
        <div class="text-center mb-5">
          <h2 class="h2-responsive font-weight-bold text-navy mb-2">
            Los 7 pilares para un laboratorio bajo control
          </h2>
          <div class="divider-green mx-auto" />
        </div>

        <div class="row">
          <!-- Pilar 1 -->
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm">
              <div class="pilar-icon-wrapper mb-3">
                <font-awesome-icon
                  :icon="['fas', 'shield-alt']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                1. Certeza Absoluta
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                LIS: Integración universal
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Serenidad al saber que cada dato es exacto, sin transcripciones
                manuales.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Elimine el estrés. Sus bioanalistas analizan; el sistema
                transfiere datos automáticamente.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Mapeo HL7/LIS compatible con todas las marcas.
                </small>
              </div>
            </div>
          </div>

          <!-- Pilar 2 -->
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm">
              <div class="pilar-icon-wrapper mb-3">
                <font-awesome-icon
                  :icon="['fas', 'comments']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                2. Atención 24/7
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                Su laboratorio siempre disponible
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Un asistente inteligente atiende consultas, orienta a sus
                pacientes y facilita cotizaciones de exámenes las 24 horas.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Envío directo a pacientes y médicos solicitantes por WhatsApp
                y correo.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Integración nativa con WhatsApp/Web.
                </small>
              </div>
            </div>
          </div>

          <!-- Pilar 3 -->
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm">
              <div class="pilar-icon-wrapper mb-3">
                <font-awesome-icon
                  :icon="['fas', 'file-signature']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                3. Resultados sin confusiones
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                Identificación desde el origen
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Genere etiquetas y utilice códigos de barras para mantener la
                trazabilidad de las muestras durante todo el proceso.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Reportes personalizables con firma digital y entrega a médicos
                y pacientes.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Trazabilidad por código de barras y entrega digital.
                </small>
              </div>
            </div>
          </div>

          <!-- Pilar 4 -->
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm">
              <div class="pilar-icon-wrapper mb-3">
                <font-awesome-icon
                  :icon="['fas', 'sliders-h']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                4. Autonomía Directiva
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                Su laboratorio, a su manera
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Configure pruebas, perfiles, paneles, reportes y flujos de
                trabajo según las necesidades de su laboratorio.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Ajuste pruebas, métodos y valores de referencia en minutos.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Catálogo autogestionable con fórmulas automáticas.
                </small>
              </div>
            </div>
          </div>

          <!-- Pilar 5 -->
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm">
              <div class="pilar-icon-wrapper mb-3">
                <font-awesome-icon
                  :icon="['fas', 'user-md']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                5. Perspectiva Humana
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                Una visión completa del paciente
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Consulte la información analítica del paciente desde las
                diferentes áreas para validar resultados con mayor contexto y
                elevar sus estándares de calidad.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Visualice tendencias históricas y detecte variaciones antes de
                validar.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Histórico evolutivo comparativo por parámetro.
                </small>
              </div>
            </div>
          </div>

          <!-- Pilar 6 -->
          <div class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm">
              <div class="pilar-icon-wrapper mb-3">
                <font-awesome-icon
                  :icon="['fas', 'chart-line']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                6. Control Impecable
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                Información para decidir mejor
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Centralice la operación y obtenga mayor visibilidad sobre sus
                procesos para gestionar su laboratorio con más control y menos
                incertidumbre.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Gestión de muestras parciales y control claro de ingresos y
                convenios.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Panel operativo, financiero y trazabilidad por código.
                </small>
              </div>
            </div>
          </div>

          <!-- Pilar 7 (Centrado) -->
          <div class="col-12 col-md-8 col-lg-4 mx-auto mb-4">
            <div class="pilar-card h-100 p-4 rounded shadow-sm text-center">
              <div class="pilar-icon-wrapper mx-auto mb-3">
                <font-awesome-icon
                  :icon="['fas', 'bolt']"
                  class="pilar-icon"
                />
              </div>
              <h3 class="h5 font-weight-bold text-navy mb-1">
                7. Adopción Inmediata
              </h3>
              <h4 class="h6 font-weight-bold text-cyan mb-3">
                Hecho para empezar
              </h4>
              <p class="pilar-body mb-2 text-secondary">
                Un proceso de implementación guiado permite que su equipo
                conozca la herramienta y comience a integrarla rápidamente en su
                operación.
              </p>
              <p class="pilar-body mb-3 text-secondary">
                Interfaz limpia que minimiza clics en horas de alto tráfico.
              </p>
              <div class="pilar-footer pt-2 border-top">
                <small class="text-muted">
                  Acompañamiento cercano y curva de aprendizaje rápida.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección 3: Matriz de Beneficios y Ecosistema -->
    <section class="section-matriz py-5 bg-light">
      <div class="container py-4">
        <h2 class="h2-responsive font-weight-bold text-center text-navy mb-4">
          Resumen de Transformación
        </h2>

        <div class="table-wrapper bg-white rounded shadow-sm mb-5">
          <table class="table table-hover table-transformacion mb-0">
            <thead class="bg-navy text-white">
              <tr>
                <th
                  scope="col"
                  class="col-desafio"
                >
                  Desafío Tradicional
                </th>
                <th
                  scope="col"
                  class="col-solucion"
                >
                  La Solución AMII Lab
                </th>
                <th
                  scope="col"
                  class="col-beneficio"
                >
                  El Beneficio
                </th>
              </tr>
            </thead>
            <tbody class="text-secondary">
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Errores por procesos manuales
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Flujo conectado entre áreas
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  Mayor control y menos margen de error
                </td>
              </tr>
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Pacientes esperando información
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Asistente inteligente 24/7
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  Atención disponible cuando el paciente la necesita
                </td>
              </tr>
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Muestras difíciles de rastrear
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Etiquetas + códigos de barras
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  Mayor trazabilidad y seguridad
                </td>
              </tr>
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Sistemas que no se adaptan
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Configuración personalizada
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  El sistema se adapta a su laboratorio
                </td>
              </tr>
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Información dispersa del paciente
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Vista integral durante la validación
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  Decisiones con mayor contexto
                </td>
              </tr>
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Resultados que requieren pasos manuales
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Transmisión directa desde los equipos
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  Más agilidad y precisión
                </td>
              </tr>
              <tr>
                <td class="col-desafio">
                  <font-awesome-icon
                    :icon="['fas', 'times-circle']"
                    class="text-danger mr-1 mr-md-2"
                  />
                  Operación difícil de supervisar
                </td>
                <td class="col-solucion font-weight-500">
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success mr-1 mr-md-2"
                  />
                  Información centralizada
                </td>
                <td class="col-beneficio text-navy font-weight-bold">
                  Mayor capacidad de gestión
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Ecosistema AMII: Instagram Embeds -->
        <div class="mt-5">
          <h3 class="h3-responsive font-weight-bold text-center text-navy mb-2">
            Conozca más sobre el Ecosistema AMII
          </h3>
          <p class="text-center text-muted mb-4">
            Tecnología, gestión y comunicación conectadas para acompañar al
            laboratorio y al paciente en todo el recorrido.
          </p>

          <div class="row justify-content-center">
            <!-- Embed AMII -->
            <div
              class="col-12 col-md-6 col-lg-5 mb-4 d-flex
                justify-content-center"
            >
              <div class="embed-box p-3 bg-white rounded shadow-sm w-100">
                <div class="d-flex align-items-center mb-3">
                  <font-awesome-icon
                    :icon="['fab', 'instagram']"
                    class="text-instagram mr-2 fa-2x"
                  />
                  <div>
                    <h4 class="h6 font-weight-bold mb-0 text-navy">
                      @amii.app
                    </h4>
                    <small class="text-muted">
                      Ecosistema de Salud y Telemedicina
                    </small>
                  </div>
                </div>
                <div class="embed-inner d-flex justify-content-center">
                  <blockquote
                    class="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/amii.app/"
                    data-instgrm-version="14"
                  >
                    <a
                      href="https://www.instagram.com/amii.app/"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-cyan font-weight-bold"
                    >
                      Ver perfil de @amii.app en Instagram
                    </a>
                  </blockquote>
                </div>
              </div>
            </div>

            <!-- Embed Tu Paciente Digital -->
            <div
              class="col-12 col-md-6 col-lg-5 mb-4 d-flex
                justify-content-center"
            >
              <div class="embed-box p-3 bg-white rounded shadow-sm w-100">
                <div class="d-flex align-items-center mb-3">
                  <font-awesome-icon
                    :icon="['fab', 'instagram']"
                    class="text-instagram mr-2 fa-2x"
                  />
                  <div>
                    <h4 class="h6 font-weight-bold mb-0 text-navy">
                      @tupacientedigital
                    </h4>
                    <small class="text-muted">
                      Capacitación y Auditoría en Salud
                    </small>
                  </div>
                </div>
                <div class="embed-inner d-flex justify-content-center">
                  <blockquote
                    class="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/tupacientedigital/"
                    data-instgrm-version="14"
                  >
                    <a
                      href="https://www.instagram.com/tupacientedigital/"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-cyan font-weight-bold"
                    >
                      Ver perfil de @tupacientedigital en Instagram
                    </a>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección 4: Próximos Pasos (CTA) -->
    <section
      id="contacto"
      class="section-cta py-5 bg-navy text-white"
    >
      <div class="container py-4 text-center">
        <h2 class="h2-responsive font-weight-bold mb-3">
          Descubra cómo puede funcionar mejor su laboratorio
        </h2>
        <p class="cta-lead lead mb-5 mx-auto text-light-blue">
          Le mostraremos cómo AMII Lab puede adaptarse a su operación,
          conectar sus procesos y mejorar la experiencia de sus pacientes.
        </p>

        <div class="steps-card p-4 p-md-5 rounded mb-5 text-left mx-auto">
          <h3
            class="h4 font-weight-bold mb-4 text-white d-flex
              align-items-center"
          >
            <font-awesome-icon
              :icon="['fas', 'calendar-check']"
              class="text-cyan mr-3"
            />
            Proceso de Implementación Fácil:
          </h3>
          <ul class="list-unstyled mb-0">
            <li class="d-flex align-items-start mb-4">
              <span class="step-badge mr-3">1</span>
              <div>
                <strong class="h6 d-block mb-1 text-white">
                  Diagnóstico Breve
                </strong>
                <p class="mb-0 text-light-blue small">
                  Evaluamos su infraestructura actual y analizadores para
                  asegurar compatibilidad total.
                </p>
              </div>
            </li>
            <li class="d-flex align-items-start mb-4">
              <span class="step-badge mr-3">2</span>
              <div>
                <strong class="h6 d-block mb-1 text-white">
                  Demostración Interactiva
                </strong>
                <p class="mb-0 text-light-blue small">
                  Simulamos flujos reales con datos de su laboratorio para que
                  vea el sistema en acción.
                </p>
              </div>
            </li>
            <li class="d-flex align-items-start">
              <span class="step-badge mr-3">3</span>
              <div>
                <strong class="h6 d-block mb-1 text-white">
                  Propuesta sin Interrupciones
                </strong>
                <p class="mb-0 text-light-blue small">
                  Diseñamos un plan de transición suave, con el entrenamiento
                  operativo y en buenas prácticas del equipo de profesionales
                  de "Tu Paciente Digital".
                </p>
              </div>
            </li>
          </ul>
        </div>

        <!-- Botón Directo Demostración -->
        <a
          href="https://ig.me/m/amii.app"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-cta-primary px-4 py-3 shadow-lg"
        >
          Solicite su Demostración
          <font-awesome-icon
            :icon="['fas', 'arrow-right']"
            class="ml-2"
          />
        </a>

        <p class="mt-3 small text-light-blue font-italic">
          Conozca la plataforma sin compromiso.
        </p>

        <p class="mt-4 small text-light-blue">
          O llámenos al:
          <a
            href="tel:+584122747740"
            class="text-white text-decoration-underline"
          >
            +58 412 2747740
          </a>
          | IG:
          <a
            href="https://instagram.com/amii.app"
            target="_blank"
            rel="noopener noreferrer"
            class="text-white text-decoration-underline"
          >
            @amii.app
          </a>
        </p>
      </div>
    </section>

    <!-- Sección 5: Preguntas Frecuentes -->
    <section
      id="faq"
      class="section-faq py-5 bg-white"
    >
      <div class="container py-4">
        <div class="text-center mb-5">
          <span class="badge-hero mb-2 d-inline-block">
            Preguntas Frecuentes
          </span>
          <h2 class="h2-responsive font-weight-bold text-navy mb-2">
            Respuestas a sus dudas sobre AMII Lab
          </h2>
          <div class="divider-green mx-auto" />
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-lg-9">
            <div
              id="faqAccordion"
              class="accordion"
            >
              <div
                v-for="(item, idx) in faqs"
                :key="idx"
                class="faq-card mb-3 rounded-lg overflow-hidden border"
              >
                <div
                  class="faq-header p-3 bg-white d-flex align-items-center
                    justify-content-between"
                  @click="toggleFaq(idx)"
                >
                  <h3 class="h6 font-weight-bold text-navy mb-0 pr-2">
                    {{ item.question }}
                  </h3>
                  <span class="faq-toggle-icon text-cyan font-weight-bold ml-2">
                    {{ activeFaq === idx ? '−' : '+' }}
                  </span>
                </div>

                <div
                  v-if="activeFaq === idx"
                  class="faq-body p-3 bg-light text-secondary small border-top"
                >
                  {{ item.answer }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Botón Flotante Instagram -->
    <a
      href="https://ig.me/m/amii.app"
      target="_blank"
      rel="noopener noreferrer"
      class="floating-ig-btn shadow-lg"
      aria-label="Contactar por Instagram"
    >
      <font-awesome-icon
        :icon="['fab', 'instagram']"
        class="floating-ig-icon"
      />
    </a>

    <!-- Footer General -->
    <appFooter />
  </div>
</template>

<script>
import appFooter from '@/components/layout/Footer.vue';

const INSTAGRAM_EMBED_SRC = 'https://www.instagram.com/embed.js';

export default {
  name: 'LabClinico',
  components: {
    appFooter,
  },
  data() {
    return {
      activeFaq: 0,
      faqs: [
        {
          question: '¿Es de pago único o recurrente?',
          answer: 'Luego de la contratación inicial, el esquema es de pago '
            + 'por uso: si en un período no procesa órdenes o no utiliza '
            + 'el sistema, no paga mensualidades fijas obligatorias.',
        },
        {
          question: '¿Cuánto cuesta la implementación de AMII Lab?',
          answer: 'La contratación inicial parte desde $800, adaptándose a '
            + 'los requerimientos de su institución y al nivel de '
            + 'acompañamiento necesario para su equipo.',
        },
        {
          question: '¿Es fácil de usar para el personal del laboratorio?',
          answer: 'Sí. La plataforma está diseñada con el usuario en mente, '
            + 'siguiendo estándares internacionales de usabilidad para que '
            + 'bioanalistas, recepcionistas y directores se adapten con '
            + 'total fluidez.',
        },
        {
          question: '¿Necesito comprar un servidor o equipos especiales?',
          answer: 'No. AMII Lab opera de forma segura en la nube y se '
            + 'comunica con sus analizadores mediante un software conector '
            + 'local sumamente ligero, sin demandar inversiones en servidores '
            + 'costosos.',
        },
        {
          question: '¿Envía resultados por WhatsApp y correo electrónico?',
          answer: 'Sí. Puede conectar su línea de WhatsApp o emitir envíos '
            + 'por correo electrónico para que tanto el paciente como el '
            + 'médico solicitante reciban sus reportes de forma ágil y segura.',
        },
      ],
    };
  },
  mounted() {
    this.disableChatwoot();
    this.loadInstagramEmbed();
  },
  beforeDestroy() {
    this.restoreChatwoot();
  },
  methods: {
    toggleFaq(idx) {
      this.activeFaq = this.activeFaq === idx ? null : idx;
    },
    disableChatwoot() {
      if (typeof window === 'undefined') return;
      const hideFn = () => {
        if (window.$chatwoot) {
          if (typeof window.$chatwoot.toggle === 'function') {
            window.$chatwoot.toggle('hide');
          } else if (typeof window.$chatwoot.hide === 'function') {
            window.$chatwoot.hide();
          }
        }
        const chatwootWidget = document.querySelector('.woot-widget-holder')
          || document.querySelector('.woot--bubble-holder')
          || document.getElementById('chatwoot-widget-container');
        if (chatwootWidget) {
          chatwootWidget.style.display = 'none';
        }
      };
      hideFn();
      setTimeout(hideFn, 300);
      setTimeout(hideFn, 1000);
    },
    restoreChatwoot() {
      if (typeof window === 'undefined') return;
      if (window.$chatwoot) {
        if (typeof window.$chatwoot.toggle === 'function') {
          window.$chatwoot.toggle('show');
        } else if (typeof window.$chatwoot.show === 'function') {
          window.$chatwoot.show();
        }
      }
      const chatwootWidget = document.querySelector('.woot-widget-holder')
        || document.querySelector('.woot--bubble-holder')
        || document.getElementById('chatwoot-widget-container');
      if (chatwootWidget) {
        chatwootWidget.style.display = '';
      }
    },
    loadInstagramEmbed() {
      if (typeof window === 'undefined') return;
      if (window.instgrm && window.instgrm.Embeds) {
        this.$nextTick(() => window.instgrm.Embeds.process());
        return;
      }
      const existing = document.querySelector(
          `script[src="${INSTAGRAM_EMBED_SRC}"]`,
      );
      if (existing) {
        existing.addEventListener('load', this.processEmbeds);
        return;
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = INSTAGRAM_EMBED_SRC;
      script.addEventListener('load', this.processEmbeds);
      document.body.appendChild(script);
    },
    processEmbeds() {
      if (window.instgrm && window.instgrm.Embeds) {
        this.$nextTick(() => window.instgrm.Embeds.process());
      }
    },
    scrollToSection(id) {
      if (typeof document === 'undefined') return;
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lab-clinico-page {
  font-family: 'Inter', sans-serif;
  color: #334155;
  background-color: #f8fafc;
  overflow-x: hidden;
  width: 100%;
}

.container {
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.hero-logos-row {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

/* Colores de Marca */
$brand-blue: #00208a;
$brand-cyan: #00b4d8;
$brand-green: #789585;
$brand-light-blue: #e6f0ff;
$brand-dark: #1e293b;

.text-navy {
  color: $brand-blue;
}

.text-cyan {
  color: $brand-cyan;
}

.text-sage {
  color: $brand-green;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.text-light-blue {
  color: #cce3ff;
}

.text-instagram {
  color: #e1306c;
}

.bg-navy {
  background-color: $brand-blue;
}

.text-gradient-cyan {
  background: linear-gradient(90deg, #00208a, #00b4d8);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.w-33 {
  width: 33.333%;
}

.font-weight-500 {
  font-weight: 500;
}

/* Hero */
.hero-section {
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.amii-animated-logo {
  display: inline-block;
  height: 70px;
  width: auto;
  overflow: visible;
}

.fil0 {
  fill: none;
}
.fil1 {
  fill: #00208a;
}
.str1 {
  stroke: #00208a;
  stroke-width: 6;
}
.str0 {
  stroke: #00208a;
  stroke-width: 9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.hero-logo-partner {
  height: 48px;
  width: auto;
  object-fit: contain;
  transition: transform 0.25s ease;

  &:hover {
    transform: scale(1.04);
  }
}

.badge-hero {
  background-color: $brand-light-blue;
  color: $brand-blue;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  border-radius: 50px;
  border: 1px solid #bfdbfe;
}

.hero-title {
  color: $brand-dark;
  font-size: 2.25rem;
  line-height: 1.25;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
}

.hero-subtitle {
  color: #64748b;
  font-size: 1.15rem;
  line-height: 1.6;
  font-style: italic;
}

.btn-cta-primary {
  background-color: $brand-blue;
  color: #ffffff;
  font-weight: 700;
  font-size: 1.1rem;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: #001766;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 32, 138, 0.25) !important;
  }
}

/* Sección 1: Intro */
.section-intro {
  background-color: $brand-light-blue;
}

.intro-card {
  background-color: #ffffff;
  border: 1px solid #dbeafe;
}

.intro-text {
  font-size: 1.05rem;
  line-height: 1.7;
}

.intro-highlight {
  background-color: #f8fafc;
  border-left: 4px solid $brand-green;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* Sección 2: Pilares */
.divider-green {
  height: 4px;
  width: 70px;
  background-color: $brand-green;
  border-radius: 2px;
}

.pilar-card {
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(0, 32, 138, 0.08) !important;
    border-color: #cbd5e1;
  }
}

.pilar-icon-wrapper {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: $brand-light-blue;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pilar-icon {
  font-size: 1.35rem;
  color: $brand-blue;
}

.pilar-body {
  font-size: 0.925rem;
  line-height: 1.55;
}

/* Sección 3: Matriz & Embeds */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.table-transformacion {
  width: 100%;
  table-layout: fixed;
  font-size: 0.82rem;

  @media (min-width: 576px) {
    font-size: 0.9rem;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
  }

  th,
  td {
    padding: 0.65rem 0.5rem;
    vertical-align: middle;
    word-break: break-word;
    white-space: normal;

    @media (min-width: 576px) {
      padding: 0.85rem 0.75rem;
    }

    @media (min-width: 768px) {
      padding: 1rem 1.25rem;
    }
  }

  thead th {
    border: none;
  }
}

.col-desafio {
  width: 32%;
}

.col-solucion {
  width: 34%;
}

.col-beneficio {
  width: 34%;
}

.embed-box {
  border: 1px solid #e2e8f0;
  min-height: 280px;
  max-width: 480px;
}

.embed-inner {
  width: 100%;
}

.instagram-media {
  margin: 0 auto !important;
  min-width: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

/* Sección 4: CTA */
.cta-lead {
  max-width: 720px;
}

.steps-card {
  max-width: 680px;
  background-color: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
}

.step-badge {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: $brand-cyan;
  color: #ffffff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-instagram-direct {
  background: linear-gradient(
    45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888
  );
  color: #ffffff;
  font-weight: 700;
  font-size: 1.15rem;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;

  &:hover {
    color: #ffffff;
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 10px 25px rgba(220, 39, 67, 0.35) !important;
  }
}

/* Floating Instagram Button */
.floating-ig-btn {
  position: fixed;
  width: 58px;
  height: 58px;
  bottom: 30px;
  right: 30px;
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fdf497 5%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.1);
    color: #ffffff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25) !important;
  }
}

.floating-ig-icon {
  font-size: 1.85rem;
}

/* Sección 5: FAQ */
.section-faq {
  border-top: 1px solid #e2e8f0;
}

.faq-card {
  border-color: #e2e8f0;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 32, 138, 0.06);
    border-color: #cbd5e1;
  }
}

.faq-header {
  cursor: pointer;
  user-select: none;
}

.faq-toggle-icon {
  font-size: 1.25rem;
  line-height: 1;
}

.faq-body {
  line-height: 1.6;
  font-size: 0.95rem;
}
</style>
